(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Merchandise renders its recommendations server side and sets no data-url.
  if (!productRecommendationsSection.dataset.url) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twiga-faq-explore"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Upgrade the fallback collection to Shopify's real recommendations once the
  // row is near the viewport. Only the products column is swapped; the FAQ
  // column in the same section is left alone. When the products column is
  // switched off it is not in the DOM at all, so this exits immediately.
  var root = document.querySelector('.twiga-explore__col--coffees[data-url]');
  if (!root || !root.dataset.url) return;

  function load() {
    fetch(root.dataset.url)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var parsed = document.createElement('div');
        parsed.innerHTML = html;
        var next = parsed.querySelector('.twiga-explore__col--coffees');
        if (next && next.innerHTML.trim()) root.innerHTML = next.innerHTML;
      })
      .catch(function () {});
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { io.disconnect(); load(); }
    }, { rootMargin: '400px' });
    io.observe(root);
  } else {
    load();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (document.querySelector('[data-section-id="' + e.detail.sectionId + '"].twiga-explore__col--coffees')) load();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twiga-related-coffees"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.twiga-related');
  if (!root || !root.dataset.url) return;

  function load() {
    fetch(root.dataset.url)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var parsed = document.createElement('div');
        parsed.innerHTML = html;
        var next = parsed.querySelector('.twiga-related');
        if (next && next.innerHTML.trim()) root.innerHTML = next.innerHTML;
      })
      .catch(function () {});
  }

  // Off the critical path: only fetch once the row is close to the viewport.
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { io.disconnect(); load(); }
    }, { rootMargin: '400px' });
    io.observe(root);
  } else {
    load();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (document.querySelector('[data-section-id="' + e.detail.sectionId + '"].twiga-related')) load();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
